/* Native policy/customer and legacy templates share the same heading placement. */
(() => {
  const placeBreadcrumb = () => {
    const main = document.getElementById('MainContent');
    const template = document.getElementById('NovaBreadcrumbTemplate');
    if (!main || !template || main.querySelector('.nova-store-crumb')) return;
    const visible = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 1 && rect.height > 1 && getComputedStyle(element).visibility !== 'hidden';
    };
    const heading = [...main.querySelectorAll('h1')].find(visible)
      || [...main.querySelectorAll('h2')].find(visible);
    if (!heading) return;
    const previous = heading.previousElementSibling;
    const anchor = previous?.matches('.nip-eyebrow, .nova-product-eyebrow') ? previous : heading;
    anchor.before(template.content.cloneNode(true));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeBreadcrumb, { once: true });
  else placeBreadcrumb();
  document.addEventListener('shopify:section:load', placeBreadcrumb);
})();
